export default __webpack_public_path__ + "c5f0b0ff80023faeadd9731f1db2f2c0.png";